import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { User, Lock, Bell, Settings as SettingsIcon } from 'lucide-react'
import { MainLayout } from '@/components/layout'
import { useDocumentTitle } from '@/hooks/use-document-title'
import { ProfileTab } from '@/features/settings/components/ProfileTab'
import { SecurityTab } from '@/features/settings/components/SecurityTab'
import { NotificationsTab } from '@/features/settings/components/NotificationsTab'

export const Route = createFileRoute('/_authenticated/settings')({
  component: SettingsPage,
})

const tabs = [
  { id: 'profile', label: 'Perfil', icon: User },
  { id: 'security', label: 'Seguranca', icon: Lock },
  { id: 'notifications', label: 'Notificacoes', icon: Bell },
]

function SettingsPage() {
  useDocumentTitle('Configurações')
  const [activeTab, setActiveTab] = useState('profile')

  return (
    <MainLayout title="Configuracoes" subtitle="Gerencie suas preferencias e configuracoes da conta">
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center gap-4">
          <div className="p-2.5 bg-gray-100 rounded-lg">
            <SettingsIcon className="h-5 w-5 text-gray-600" />
          </div>
          <div>
            <p className="text-sm text-gray-500">
              Personalize sua experiencia
            </p>
          </div>
        </div>

        {/* Tabs */}
        <div className="card p-1 inline-flex gap-1 flex-wrap">
          {tabs.map((tab) => {
            const Icon = tab.icon
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                  activeTab === tab.id
                    ? 'bg-teal-500 text-white'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </button>
            )
          })}
        </div>

        {/* Conteudo das tabs */}
        <div className="card p-6">
          {activeTab === 'profile' && <ProfileTab />}
          {activeTab === 'security' && <SecurityTab />}
          {activeTab === 'notifications' && <NotificationsTab />}
        </div>
      </div>
    </MainLayout>
  )
}
